import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import {Link} from "react-router-dom";
function Block8() {

    return (
            <section className="layout-pt-20 layout-pb-20" style={{background: "#F5F9FE"}}>
                <div className="auto-container">

                    <div className="sec-title-outer">
                        <div className="sec-title" style={{width: "100%", textAlign: "center"}}>
                            <h2 className="homepage">Nos autres dispositifs pour soutenir <span>votre politique handicap inclusive</span></h2>
                            <div className="text homepage">
                                Découvrez comment les Forums en ligne Talents Handicap et Talents Handicap Formation contribuent avec synergie et efficacité, à différents axes de votre politique handicap,
                                pour vous accompagner dans le recrutement, la formation, la sensibilisation et la communication.
                            </div>
                        </div>
                    </div>

                    <div className="row wow fadeInUp">
                        <div className="banner-style-one -type-2 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-box"
                                 style={{backgroundImage: "url('images/index-13/banner/banner-generique.jpg')", backgroundPositionX: "center"}}>
                                <div className="content">
                                    <h3>Forums en ligne Talents Handicap</h3>
                                    <p>Participez aux Forums Talents Handicap pour recruter des talents en situation de handicap et valoriser votre engagement.</p>
                                    <Link to="https://www.talents-handicap.com/" rel="noopener noreferrer" target="_blank" className="theme-btn homepage btn-style-six small mt-3">Rejoignez nos forums</Link>
                                </div>
                                <figure className="image" style={{display: "none"}}><img src="images/resource/employ.png" alt=""/></figure>
                            </div>
                        </div>

                        <div className="banner-style-two homepage -type-2 col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-box"
                                 style={{backgroundImage: "url('images/index-13/banner/banner-thf.jpg')", backgroundPositionX: "center"}}>
                                <div className="content">
                                    <h3 className="color-dark-1">Talents Handicap Formation</h3>
                                    <p className="color-dark-2">Proposez des formations inclusives pour sensibiliser vos équipes et vos managers aux enjeux du handicap.</p>
                                    <Link to="https://formation.talents-handicap.com/" rel="noopener noreferrer" target="_blank" className="theme-btn homepage btn-style-one small mt-3">Découvrez nos formations</Link>
                                </div>
                                <figure className="image" style={{display: "none"}}><img src="images/resource/candidate.png" alt=""/></figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block8;
